export let getServermasterNewArticleTpl = function (data) {
  return `<section class="section-servermaster">
              <header>
                <h3>전체 서버지기 최신기사</h3>
              </header>
              <article class="article-list"></article>
            </section>`;
};

export let getMyServermasterTpl = function (data) {
  return `<section class="section-servermaster-my">
            <header>
              <h3>우리서버 서버지기&최신기사</h3>
            </header>
            <article class="article-myservermaster">
              <ul class="has-6">
                <!--
                <li><span class="flag COVERAGE"></span> servermaster name </li>
                <li><span class="flag COLUMN"></span> servermaster name </li>
                <li><span class="flag REVIEW"></span> servermaster name </li>
                -->
              </ul>
            </article>

            <header>
              <h3>우리서버 최신기사</h3>
            </header>
            <article class="article-list">
              <ul>
                <!-- <li><a class="title" href="">title</a><span class="writer">character name</span></li> -->
              </ul>
            </article>
          </section>`;
};


// WEBPACK FOOTER //
// ./_src/js/board/servermaster/tpl.js